module.exports = __webpack_public_path__ + "img/login-img.883efce5.png";